/**
 * License Expiry Banner Component
 *
 * Displays a warning banner when e-learning licenses are about to expire.
 * Only shows if expiration is within 1 month.
 */

import React from 'react';

import './style.scss';

interface LicenseExpiryBannerProps {
  /** Unix timestamp of when licenses expire */
  expiryTimestamp: number | undefined;
  /** Translation function */
  t: (key: string, options?: Record<string, unknown>) => string;
}

/**
 * Renders the license expiry banner when licenses expire within 1 month
 */
const LicenseExpiryBanner: React.FC<LicenseExpiryBannerProps> = ({ expiryTimestamp, t }) => {
  if (!expiryTimestamp) return null;

  const expiryDate = new Date(expiryTimestamp * 1000);
  const oneMonthFromNow = new Date();
  oneMonthFromNow.setMonth(oneMonthFromNow.getMonth() + 1);

  // Only show banner if expiring within 1 month
  if (expiryDate > oneMonthFromNow) return null;

  const formattedDate = expiryDate.toLocaleDateString('nl-NL', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });

  return (
    <div className="LicenseExpiryBanner">
      <p>{t('mijn_vnl.orders.licenses_expire_on', { date: formattedDate })}</p>
    </div>
  );
};

export default LicenseExpiryBanner;
